<template>
  <div>
    <div class="tournament-cover">
      <div class="background-cover">
        <b-img-lazy :alt="tournament.name" :src="imgCoverDataUrl" v-if="imgCoverDataUrl"></b-img-lazy>
      </div>
      <div class="tournament-header">
        <div class="content">
          <figure class="tournament-badge">
            <b-img :src="tournament.badge.url"/>
          </figure>
          <h1>{{tournament.name}}</h1>
          <span class="time">Início em {{tournament.starts_at}}</span>
        </div>
      </div>

      <my-upload
        field="img"
        v-model="coverShow"
        v-if="isTournamentAdmin"
        :width="1980"
        :height="500"
        langType="pt-br"
        noCircle
        @crop-success="coverCropSuccess"
        @crop-upload-success="coverCropUploadSuccess"
        @crop-upload-fail="coverCropUploadFail"
        :url="coverUploadUrl"
        :params="coverParams"
        :headers="coverHeaders"
        img-format="jpg"
      ></my-upload>

      <a
        class="btn btn-change-cover"
        @click="coverToggleShow"
        v-if="isTournamentAdmin"
      >alterar cover</a>
    </div>
    <div class="tournament-menu">
      <router-link :to="{ name: 'TournamentSingle', params: { id: tournament.slug }}">
        <i class="fas fa-home"></i>
        Inicial
      </router-link>

      <router-link
        v-if="tournament.matches"
        :to="{ name: 'TournamentMatches', params: { id: tournament.slug }}"
      >
        <i class="fas fa-list"></i>
        Partidas
      </router-link>

      <router-link
        v-if="tournament.matches.length"
        :to="{ name: 'TournamentStats', params: { id: tournament.slug }}"
      >
        <i class="fas fa-chart-bar"></i>
        Estatísticas
      </router-link>

      <a
        :href="tournament.brackets_url"
        v-if="!tournament.brackets_handled_by_us && tournament.brackets_url"
      >
        <i class="fas fa-project-diagram"></i>
        Tabela
      </a>

      <router-link
        v-if="isTournamentAdmin"
        :to="{ name: 'TournamentAdmin', params: { id: tournament.slug }}"
      >
        <i class="fas fa-chart-bar"></i>
        Admin
      </router-link>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.tournament-cover
  height: 500px
  position: relative
  background: #ddd
  border-bottom: 1px solid #3f3f3f
  .background-cover
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    overflow: hidden
    > img
      width: auto
      height: 100%
      position: relative
      // left: -700px

  a.btn-change-cover
    position: absolute
    bottom: 0
    right: 0
    color: white
    @media (max-width: 600px)
      z-index: 4
      display: none

  .tournament-header
    background: rgb(5,5,5)
    background: linear-gradient(90deg, rgba(5,5,5,0.8) 94%, rgba(138,138,138,0) 98%)
    height: 100%
    width: 400px
    z-index: 2
    position: relative
    color: white
    padding: 20px 40px 20px 20px

    display: flex
    align-items: flex-end

    @media (max-width: 600px)
      width: 100%
    .content

.tournament-menu
  background: #131313
  padding: 10px
  border-bottom: 1px solid #fff

  text-align: center
  font-family: 'Oswald', sans-serif
  text-transform: uppercase
  // font-weight: bold
  font-size: 18px

  a
    color: rgba(white, .4)
    margin: 0 5px
    // padding: 0 5px
    padding-left: 20px
    border-left: 1px solid rgba(white, .4)
    @media (max-width: 600px)
      display: block
      border-left: 0
      padding: 0
      margin: 0

    &:first-child
      // border-right: 1px solid white
      padding-left: 0
      border-left: 0

    &:hover
      text-decoration: none
      color: white
      // font-weight: bold
</style>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  name: "TournamentCover",
  props: {
    tournament: Object
  },
  data() {
    return {
      imgCoverDataUrl: "",
      coverShow: false,
      coverParams: {
        name: "cover"
      },
      coverHeaders: {
        Authorization: localStorage.getItem("token")
      },
      coverUploadUrl: `${
        window.location.hostname == "queota.club"
          ? "https://api.queota.club"
          : "http://localhost:5000"
      }/tournaments/${this.$route.params.id}/cover.json`
    };
  },
  computed: {
    isTournamentAdmin: function() {
      return (
        this.$store.getters.isLoggedIn &&
        this.tournament &&
        this.tournament.tournament_staff &&
        this.tournament.tournament_staff
          .map(i => i.user.id)
          .includes(this.$store.getters.user.id)
      );
    }
  },

  methods: {
    initialize() {
      // console.log("passei", this.tournament, this.tournament.cover);
      // this.imgCoverDataUrl = this.tournament.cover.url;
    },

    coverToggleShow() {
      this.coverShow = !this.coverShow;
    },
    coverCropSuccess(imgDataUrl, field) {
      this.imgCoverDataUrl = imgDataUrl;
    },
    coverCropUploadSuccess(jsonData, field) {
      // this.imgDataUrl = jsonData.cover.url
      this.$notify({
        group: "all",
        title: "Cover alterado com sucesso"
      });
    },
    coverCropUploadFail(status, field) {
      this.imgCoverDataUrl = this.user.cover.url;
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "tournament.cover": function(cover) {
      if (cover && cover.url) this.imgCoverDataUrl = cover.url;
    }
  },
  components: {
    "my-upload": myUpload
  }
};
</script>
